export default {"src":"/_next/static/media/info.ef9bedcf.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};